<template>
  <div id="app">
    <Upload v-if="login"></Upload>
    <Login v-if="!login" @entrar="login = true"></Login>
  </div>
</template>
  
<script>
import Upload from './components/Upload.vue'
import Login from './components/Login.vue'
   
export default {
  name: 'app',
  components: {
    Upload,
    Login
  },
  data() {
    return{
      login: false,
    }
  }
}
</script>